<template>
  <component :is="tag" class="section" :class="classes">
    <slot />
  </component>
</template>
<script lang="ts" setup>
interface Props {
  theme?: string;
  stroke?: string;
  variant?: 'tonal' | 'outlined';
  tag?: 'section' | 'div' | 'nav';
  padding?: boolean;
  elevate?: boolean;
  gap?: 'xs' | 's' | 'n' | 'm' | 'l' | 'xl';
}
const props = defineProps({
  theme: { default: 'none' },
  stroke: { default: null },
  variant: { default: null },
  tag: { default: 'section' },
  padding: { type: Boolean, default: false },
  elevate: { type: Boolean, default: false },
  gap: { default: 'n' }
});

const classes = computed(() => {
  const cls = [];
  if (props.variant) cls.push(props.variant);
  if (props.theme) cls.push(props.theme);
  if (props.stroke) cls.push(`stroke-${props.stroke}`);
  if (props.elevate) cls.push(`elevate`);
  if (props.padding) cls.push(`padding`);
  cls.push('gap-' + props.gap);
  return cls;
});
</script>
<style lang="scss" scoped>
.section {
  display: flex;
  flex-direction: column;

  @include above('l') {
    padding: 0;
  }
  &.padding {
    padding: var(--gap_m);
  }

  &.gap-xs {
    gap: var(--gap_xs);
  }

  &.gap-s {
    gap: var(--gap_s);
  }
  &.gap-n {
    gap: var(--gap_n);
  }
  &.gap-m {
    gap: var(--gap_m);
  }
  &.gap-l {
    gap: var(--gap_l);
  }
  &.gap-xl {
    gap: var(--gap_xl);
  }
}
</style>
